module.exports = __webpack_public_path__ + "static/media/dataScience.114b40b9.svg";